import dashboard from './dashboard';
import projects from './projects';
import repositories from './repositories';
import analytics from './analytics';
import agents from './agents';
import integrations from './integrations';
import settings from './settings';
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
  items: [dashboard, analytics, repositories, projects, agents, integrations, settings]
};

export default menuItems;
